import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Header {
  chainUid: string;
  unitUid: string;
  acctNo: string;
};

const initialState: Header = {
  chainUid: '',
  unitUid: '',
  acctNo: '',
};

const headerSlice = createSlice({
  name: 'header',
  initialState,
  reducers: {
    setHeader: (state, action: PayloadAction<Partial<Header>>) => {
      return {...state, ...action.payload};
    },
    resetHeader: () => initialState
  },
});

export const { setHeader, resetHeader } = headerSlice.actions;

export default headerSlice.reducer;
